import { requestGet, requestPostFile, requestPost } from "../config/Api";
import { downloadFilePost } from "./ReportService";

const name = "payment/order";


export const getPaymentOrder = (params) => {
  return requestGet(name, { params });
};

export const getGeneratePaymentOrders = (params) => {
  return requestGet(`payment/order/generate/by-lawyer`, { params });
};

export const createUploadLegalFile = (legalFile) => {
  return requestPostFile(`${name}/data/file`, legalFile);
};

export const previewUploadLawyers = (legalFile) => {
  return requestPostFile(`${name}/data/file/preview-lawyers`, legalFile);
};

export const refreshPaymentOrdersByLegalFileId = (legalFileId) => {
  return requestPost(`payment/order/refresh/${legalFileId}`);
};

export const downloadRetentionReport = (payload) => {
  return downloadFilePost("payment/order/report/retentions", payload);
};
